<h6> {{'COLOR_CHANGE_LOG' }} </h6>
<div *ngFor="let change of changes" class="row" [ngClass]="change.color">
  <span fxFlex="200px"> {{change.color}}</span>
  <span fxFlex="100px">{{change.historyDate | date}}</span>
  <span fxLayoutAlign="start center"><mat-icon inline="true">email</mat-icon>{{change.historyUser.email}}</span>
</div>
